import { VegaQumuloPalette } from './VegaQumuloPalette';
import createTypography from '@mui/material/styles/createTypography';

export const VegaQumuloTypography = createTypography(VegaQumuloPalette, {
    fontFamily: ['"Rubik"', 'sans-serif'].join(','),
});
